import { lazy, Suspense } from 'react';
import { useAuth } from './context/AuthContext';
import { Routes, Route, Navigate } from 'react-router-dom';

const ProtectedLayout = lazy(() => import('./components/layout/ProtectedLayout'));
const LogInPage = lazy(() => import('./pages/LogInPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));

const Dashboard = lazy(() => import('./pages/Dashboard').then(m => ({ default: m.Dashboard })));
const Files = lazy(() => import('./pages/Files').then(m => ({ default: m.Files })));
const Users = lazy(() => import('./pages/Users').then(m => ({ default: m.Users })));
const Settings = lazy(() => import('./pages/Settings').then(m => ({ default: m.Settings })));
const HomeContent = lazy(() => import('./pages/HomeContent').then(m => ({ default: m.HomeContent })));
const ContactManagement = lazy(() => import('./pages/ContactManagement').then(m => ({ default: m.ContactManagement })));
const WebsitePages = lazy(() => import('./pages/WebsitePages').then(m => ({ default: m.WebsitePages })));
const PricingPlans = lazy(() => import('./pages/PricingPlans').then(m => ({ default: m.PricingPlans })));
const Media = lazy(() => import('./pages/Media').then(m => ({ default: m.Media })));
const AnalyticsPage = lazy(() => import('./pages/Analytics').then(m => ({ default: m.AnalyticsPage })));
const LiveShares = lazy(() => import('./pages/LiveShares').then(m => ({ default: m.LiveShares })));
const EmailManagement = lazy(() => import('./pages/EmailManagment').then(m => ({ default: m.EmailManagement })));
const BrandingPresetsPage = lazy(() => import('./pages/BrandingPresetsPage'));
const FoldersPage = lazy(() => import('./pages/FoldersPage').then(m => ({ default: m.FoldersPage })));
const UploadAttemptsPage = lazy(() => import('./pages/UploadAttemptsPage'));
const NewsletterAdmin = lazy(() => import('./pages/NewsletterAdmin'));
const AdminBlogsList = lazy(() => import('./pages/AdminBlogsList').then(m => ({ default: m.AdminBlogsList })));
const AdminUpdatesPage = lazy(() => import('./pages/AdminUpdatesPage'));
const AdminLogsPage = lazy(() => import('./pages/AdminLogsPage'));
const FilesBackup = lazy(() => import('./pages/FilesBackup').then(m => ({ default: m.FilesBackup })));
const AdminRedisRealtimePage = lazy(() => import('./pages/AdminRedisRealtimePage').then(m => ({ default: m.AdminRedisRealtimePage })));
function App() {
	const { isAuthenticated } = useAuth();

	return (
		<Suspense fallback={<div className="p-6">Loading…</div>}>
			<Routes>
				<Route
					path="/login"
					element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LogInPage />}
				/>
				<Route
					path="/register"
					element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <RegisterPage />}
				/>

				{/* Protected */}
				<Route element={<ProtectedLayout />}>
					<Route path="/" element={<Navigate to="/dashboard" replace />} />
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/files" element={<Files />} />
					<Route path="/files-backup" element={<FilesBackup />} />
					<Route path="/folders" element={<FoldersPage />} />
					<Route path="/users" element={<Users />} />
					<Route path="/home-content" element={<HomeContent />} />
					<Route path="/contact-management" element={<ContactManagement />} />
					<Route path="/website-pages" element={<WebsitePages />} />
					<Route path="/pricing-plans" element={<PricingPlans />} />
					<Route path="/media" element={<Media />} />
					<Route path="/analytics" element={<AnalyticsPage />} />
					<Route path="/live-shares" element={<LiveShares />} />
					<Route path="/settings" element={<Settings />} />
					<Route path="/email-management" element={<EmailManagement />} />
					<Route path="/admin-blogs" element={<AdminBlogsList />} />
					<Route path="/admin/updates" element={<AdminUpdatesPage />} />
					<Route path="/branding" element={<BrandingPresetsPage />} />
					<Route path="/upload-attempts" element={<UploadAttemptsPage />} />
					<Route path="/newsletter" element={<NewsletterAdmin />} />
					<Route path="/logs" element={<AdminLogsPage />} />
					<Route path="/admin/redis-realtime" element={<AdminRedisRealtimePage />} />
				</Route>
				<Route path="*" element={<Navigate to="/dashboard" replace />} />
			</Routes>
		</Suspense>
	);
}

export default App;
